import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CaretRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

import { isExternalLink } from 'enrollment/utils/common/Utils';
import './scss/NavLinks.css';

export interface NavLinksProps {
  navRoutes: object[];
  selectedLocation?: string;
  planYearContext?: string;
  mainLink?: boolean;
}

export const NavLinks: FC<NavLinksProps> = ({
  navRoutes,
  selectedLocation,
  planYearContext,
  mainLink = false,
}) => {
  const { t } = useTranslation();

  const navigationLinks = navRoutes.map((route: any, index: number) => {
    const isSelected =
      route.location === (selectedLocation ?? '') &&
      route.planYear === (planYearContext ?? '');

    const externalLink = isExternalLink(route.path) ? (
      <a
        href={route.path}
        className={`${isSelected ? 'selected' : ''} ${mainLink ? 'main-link' : ''}`}
      >
        {t(route.name)}
        <CaretRight
          className="caret-icon"
          size={16}
          weight="bold"
          aria-hidden="true"
          role="presentation"
        />
      </a>
    ) : (
      <Link
        to={route.path}
        className={`${isSelected ? 'selected' : ''} ${mainLink ? 'main-link' : ''}`}
      >
        {t(route.name)}
        <CaretRight
          className="caret-icon"
          size={16}
          weight="bold"
          aria-hidden="true"
          role="presentation"
        />
      </Link>
    );

    const buttonLink = (
      <button
        className={`${isSelected ? 'selected' : ''} ${mainLink ? 'main-link' : ''}`}
        onClick={route.handleClick}
      >
        {t(route.name)}
        <CaretRight
          className="caret-icon"
          size={16}
          weight="bold"
          aria-hidden="true"
          role="presentation"
        />
      </button>
    );

    return <li key={index}>{route.handleClick ? buttonLink : externalLink}</li>;
  });

  return <ul className="nav-links">{navigationLinks}</ul>;
};
